import { useEffect } from "react";
import { fetchConfigMerchandiseCategoryListAction } from "../../../../redux/actions/config/merchandiseCategory";
import { useAppDispatch, useAppSelector } from "../../../../redux/hooks";
import { CustomDetailsList } from "../../../common/customDetailsList/customDetailsList";
import { Skeleton } from "../../../common/skeleton/skeleton";
import { ConfigMerchandiseCategoryListColumns } from "./column/column";
import { SkeletonSizes } from "../../../../common/enum/sizes";
import { sortArray } from "../../../../utils";

export const ConfigMerchandiseCategoryList = () => {
    const { list, loading, sort } = useAppSelector((state) => state.configMerchandiseCategoryList);
    const dispatch = useAppDispatch();

    const renderColumns = () => {
        return ConfigMerchandiseCategoryListColumns();
    };

    useEffect(() => {
        list === undefined && dispatch(fetchConfigMerchandiseCategoryListAction());
    }, [list]);

    return (
        <div style={{ height: "100%" }}>
            {loading ? (
                <Skeleton rows={SkeletonSizes.DEFAULT} />
            ) : (
                <CustomDetailsList
                    data={sortArray(list, sort) ?? []}
                    renderColumns={renderColumns}
                    height={"calc(100vh - 14.5rem)"}
                />
            )}
        </div>
    );
};
